// Content pages (guide, FAQ, legal…): the shared page chrome and, where the page allows, ads.
import { startPage } from './page-chrome';

startPage();
